import React from "react";
import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./Video.css";

const Video = () => {
  const [playVideo, setPlayVideo] = useState(false);
  return (
    <>
      <div className="video-section container">
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex justify-content-center mt-lg-5 mt-md-3">
              <video
                src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/BBT%20Video.mp4"
                loading="lazy"
                controls
                autoPlay
                muted
                loop
                style={{
                  height: "50%",
                  width: "85%",
                  borderRadius: "10px",
                  borderRight: "1px solid transparent"
                }}
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Video;
